import PropTypes from 'prop-types';
import React from 'react';
import { Badge, Button } from '@opendate-app/setlist';

const PayoutBankAccountBadge = ({ onSetUp }) => (
  <div className="d-flex align-items-center flex-wrap mt-2">
    <Badge color="warning" size="sm" className="mr-2">No payout bank account</Badge>
    <Button variant="link-color" size="sm" onClick={onSetUp}>
      Set up
    </Button>
  </div>
);

PayoutBankAccountBadge.propTypes = {
  onSetUp: PropTypes.func.isRequired
};

export default PayoutBankAccountBadge;
